import React from "react";
import Spinner from "../UISpinner/UISpinner.js";
import BaseModal from "../Modals/BaseModalV2.js";

const DeleteDeviceModal = ({ isOpen, handleClose, submitHandler, deviceData, isLoading }) => {

    return (
        <>
            <BaseModal
                isOpen={isOpen}
                toggle={handleClose}
                headerContent={<div className="w-100 text-center">Delete Device</div>}
                submitText="Delete"
                size="md"
                onSubmit={(e) => submitHandler(e)}
                onCancel={() => handleClose()}
                disableSubmit={isLoading}
                disableCancel={isLoading}
            >
                {!isLoading && <>
                    <p className="text-center">Are you sure you want to delete this device?</p>
                    <div className="bottom-border"></div>
                    <div>
                        <p className="delete-warning-txt text-center small">
                            *Device will no longer be visible on your Devices Dashboard.
                        </p>
                    </div>
                </>}
                {isLoading && <Spinner text="Deleting device..." />}
            </BaseModal>

        </>

    );

}

export default DeleteDeviceModal;